import styled from 'styled-components';

import colors from 'styles/colors';

const { white, gray01, darkBlue } = colors;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${white};
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0px 1px 10px rgba(219, 219, 219, 0.2),
    0px 4px 5px rgba(219, 219, 219, 0.12), 0px 2px 4px rgba(219, 219, 219, 0.14);
  position: relative;

  * {
    cursor: default;
  }

  div > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 4px;

    p:last-child {
      margin-top: 0;
      margin-left: 16px;
    }
  }

  div ~ div:last-child > button svg {
    cursor: pointer;
  }

  div > p {
    display: block;
    margin-bottom: 0;
    font-weight: 400;
    color: ${gray01};

    &:not(:first-child) {
      margin-top: 4px;
    }

    div p:last-child {
      margin-top: 0;
    }

    small {
      margin-left: 4px;
      font-size: 16px;
      opacity: 0.6;
    }

    span {
      margin-right: 4px;

      &:nth-child(2) {
        margin-left: 16px;
      }
    }

    span:nth-child(2) {
      margin-left: 16px;
    }
  }

  span {
    display: inline-block;
    font-weight: 700;
    color: ${darkBlue};
  }
`;
